import React from 'react';
import './footer.css';
import {FiInstagram} from 'react-icons/fi';
import { RiTwitterLine } from 'react-icons/ri';
import {FiGithub} from 'react-icons/fi';
import { FiLinkedin } from 'react-icons/fi';

const footer = () => {
  return (
    <footer>
      <a href='#' className='footer__logo'>Lucky Yadav</a>

      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        {/*
        <li><a href='#testimonials'>Testimonials</a></li>*/}
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className='footer__socials'>
      <a href='https://www.instagram.com/utkarshyadav15/'><FiInstagram/></a>
      <a href='https://www.linkedin.com/in/lucky-yadav-19b403232/'><FiLinkedin/></a>
      <a href='https://github.com/LuckYYadav15'><FiGithub/></a>
      </div>

      <div className='footer__copyright'>
      <small>&copy; Lucky Yadav, All rights reserved.</small>
      </div>
    </footer>
  )
}

export default footer